export default "__VITE_ASSET__726bbd35__"